/*
 * WD Sample Modal
 * Opens an inline preview of sample report pages when the customer clicks
 * any element marked [data-sample="essential"] or [data-sample="full"].
 * Renders pre-rendered WebP page images lazily so the first page paints
 * almost instantly and pages 2-N stream in as the customer scrolls.
 */
(function () {
  'use strict';

  var modal = document.getElementById('wd-sample-modal');
  var configEl = document.getElementById('wd-sample-modal-config');
  if (!modal || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  // Locale bundle (multibrand SM chunk, mirrors birth-data-form.js): every
  // customer-visible JS-built string resolves config-first from the Liquid
  // JSON block (locale-catalog-fed "strings"), falling back per key to the
  // byte-identical EN literals below. SM_DEFAULT is the ONLY place these
  // literals may live (offline test-pinned); [bracket] tokens are
  // substituted by fillTemplate.
  var SM_DEFAULT = {
    pageAlt: "[title], page [page]",
    inlineCtaText: "Yours would be about you.",
    orderCta: "Order this report",
    footReading: "Reading: [title]"
  };

  var strings = config.strings && typeof config.strings === 'object' ? config.strings : {};
  function t(key) {
    var value = strings[key];
    return typeof value === 'string' ? value : SM_DEFAULT[key];
  }

  // Single-pass substitution: inserted values are never rescanned, so a
  // title that itself contains "[page]" stays literal (Sol SM-F3).
  function fillTemplate(template, params) {
    return String(template).replace(/\[([a-z_]+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match;
    });
  }

  var pagesContainer = modal.querySelector('[data-wd-modal-pages]');
  var labelEl = modal.querySelector('[data-wd-modal-label]');
  var titleEl = modal.querySelector('[data-wd-modal-title]');
  var footLabelEl = modal.querySelector('[data-wd-modal-foot-label]');
  var ctaEl = modal.querySelector('[data-wd-modal-cta]');
  var endEl = modal.querySelector('[data-wd-modal-end]');
  var bodyEl = modal.querySelector('[data-wd-modal-body]');
  var closeButtons = modal.querySelectorAll('[data-wd-modal-close]');

  var lastFocus = null;
  var currentTier = null;

  function buildPages(tier) {
    var data = config[tier];
    if (!data || !data.pages) return null;
    var frag = document.createDocumentFragment();
    var ctaInterval = 10;
    data.pages.forEach(function (url, i) {
      var holder = document.createElement('div');
      holder.className = 'wd-sample-modal__page-holder';
      var img = document.createElement('img');
      img.className = 'wd-sample-modal__page';
      img.alt = fillTemplate(t('pageAlt'), { title: data.title, page: i + 1 });
      img.width = 1100;
      img.height = 1557;
      img.src = url;
      if (i < 2) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
      } else {
        img.loading = 'lazy';
        img.decoding = 'async';
      }
      holder.appendChild(img);
      frag.appendChild(holder);

      var pageNumber = i + 1;
      var isLastPage = pageNumber === data.pages.length;
      if (pageNumber % ctaInterval === 0 && !isLastPage) {
        // Built with createElement/text nodes so the localized strings and
        // the product URL never pass through HTML parsing; only the STATIC
        // trusted SVG stays an innerHTML literal (10b-i DOM-hygiene law).
        var cta = document.createElement('div');
        cta.className = 'wd-sample-modal__inline-cta';
        var ctaText = document.createElement('p');
        ctaText.className = 'wd-sample-modal__inline-cta-text';
        ctaText.textContent = t('inlineCtaText');
        var ctaBtn = document.createElement('a');
        ctaBtn.className = 'wd-sample-modal__inline-cta-btn';
        ctaBtn.href = data.productUrl;
        ctaBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 5l7 7-7 7"/></svg>';
        ctaBtn.insertBefore(document.createTextNode(t('orderCta')), ctaBtn.firstChild);
        cta.appendChild(ctaText);
        cta.appendChild(ctaBtn);
        frag.appendChild(cta);
      }
    });
    return frag;
  }

  function openModal(tier) {
    var data = config[tier];
    if (!data) return;

    currentTier = tier;
    lastFocus = document.activeElement;

    pagesContainer.innerHTML = '';
    var frag = buildPages(tier);
    if (!frag) return;
    pagesContainer.appendChild(frag);

    labelEl.textContent = data.label;
    titleEl.textContent = data.title;
    footLabelEl.textContent = fillTemplate(t('footReading'), { title: data.title });
    ctaEl.href = data.productUrl;
    if (endEl) {
      endEl.hidden = false;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wd-sample-modal-open');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });

    // Reset scroll to top of body so they always start at the cover page.
    if (bodyEl) bodyEl.scrollTop = 0;

    // Move focus into the modal for accessibility.
    var firstClose = modal.querySelector('.wd-sample-modal__close');
    if (firstClose) firstClose.focus({ preventScroll: true });
  }

  function closeModal() {
    if (modal.hidden) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wd-sample-modal-open');
    setTimeout(function () {
      modal.hidden = true;
      pagesContainer.innerHTML = '';
    }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
    currentTier = null;
  }

  // Click handler on any sample trigger anywhere in the document.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sample]');
    if (!trigger) return;
    var tier = trigger.getAttribute('data-sample');
    if (!config[tier]) return;
    // Allow modifier-clicks to do their normal browser thing (open in new tab).
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openModal(tier);
  }, false);

  // Close button(s).
  Array.prototype.forEach.call(closeButtons, function (btn) {
    btn.addEventListener('click', closeModal);
  });

  // ESC closes.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (modal.hidden) return;
    closeModal();
  });

  // Simple focus trap: keep Tab within the modal while open.
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (modal.hidden) return;
    var focusables = modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();
